export default function Rough() {
    return (
        <div className="section">
            Chill dude...  <br />
            <li>
                <a href="/files/codes.txt" download="codes.txt">Download</a>
            </li>
        </div>
    );
}